const defaultOptions = {
  currency: 'BRL',
  locale: 'pt-BR',
}
const formatCurrency = (value, options) => {
  const mergedOptions = { ...defaultOptions, ...options }
  const formated = new Intl.NumberFormat(mergedOptions.locale, {
    style: 'currency',
    currency: mergedOptions.currency,
  }).format(value)

  return formated
}

export default formatCurrency
